import { SchemaSchedulerV3Service } from './service';
import { QueryEndpointName } from './types';

// NOTE: these keys will get reset on new login (handlePostLogin function handle that)
export const LOCAL_STORAGE_KEYS = {
  waitlistInfoModalDismissedPrefix: 'weave.schedule-waitlist-intro-modal-dismissed',
  // SP-TODO: remove this after few weeks as we were adding this to just remove it from user's local-storage (and its no longer used)
  v3UIFF: 'weave.scheduler-v3-ui-ff-override',
  v3OperatoryFF: 'weave.operatory-v3-ff-override',
  waitlistFF: 'weave.schedule-waitlist-ff-override',
  directSchedulingFF: 'weave.schedule-waitlist-direct-scheduling-ff-override',
  appointmentPanelFF: 'weave.schedule-new-appointment-panel-ui-ff-override',
  calendarBlockUIFF: 'weave.schedule-calendar-block-ui-ff-override',
  columnReorderingFF: 'weave.schedule-calendar-columns-reordering-ff-override',
  apptReorderingFF: 'weave.schedule-calendar-appointments-reordering-ff-override',
  calendarExpandCollapseFF: 'weave.schedule-calendar-expand-collapse-ff-override',
};

export const CALENDAR_VIEW_V3_API_QUERY_LIMIT = 500;

export const DEFAULT_TIME_FIELD_SCROLL_TO_TIME = '07:00 AM';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'GetProvider',
  'ListProviders',
  'ListProvidersMulti',
  'ListMappings',
  'ListCalendarEvents',
  'ListCalendarEventsMulti',
  'ListCalendarEventsByOwner',
  'GetCalendarEvent',
  'ListSchedules',
  'ListBookingSubmissions',
  'GetBookingSubmission',
  'GetOperatory',
  'ListOperatories',
  'ListOperatoriesMulti',
  'GetAppointmentType',
  'ListAppointmentTypes',
  'ListAppointmentTypesMulti',
  'FeatureFlagStatus',
  'ListCalendarAvailabilities',
  'ListSourceTenants',
  'ListLocationSettings',
  'GetWaitlistInvitationDetails',
  'ListGroupedBookableAppointmentTypes',
] as const satisfies (keyof typeof SchemaSchedulerV3Service)[];
export const INFINITE_QUERY_ENDPOINT_NAMES = [
  'ListAppointmentTypesMulti',
  'ListAppointmentTypes',
  'ListProviders',
  'ListProvidersMulti',
  'ListBookingSubmissions',
  'ListCalendarEventsByAttendee',
] as const satisfies (keyof typeof SchemaSchedulerV3Service)[];
export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = [
  'ArchiveProvider',
  'CreateProvider',
  'UpdateProvider',
  'DeleteProviders',
  'CreateMappings',
  'DeleteMappings',
  'CreateCalendarEvent',
  'UpdateCalendarEvent',
  'UpdateCalendarEventStatus',
  'CreateSchedule',
  'UpdateSchedule',
  'DeleteSchedules',
  'CreateBookingSubmission',
  'UpdateBookingSubmission',
  'DeleteBookingSubmission',
  'CreateOperatory',
  'UpdateOperatory',
  'DeleteOperatories',
  'CreateAppointmentType',
  'UpdateAppointmentType',
  'DeleteAppointmentTypes',
  'AppointmentWriteBack',
  'AppointmentStatusWriteBack',
  'PersonWriteBack',
  'CreateLocationSettings',
  'UpdateLocationSettings',
  'BulkUpdateAppointmentTypesColors',
  'DeleteCalendarsEvent',
  'SendWaitlistInvitations',
  'ConfirmWaitlistInvitation',
  'PatchCalendarEvent',
  'BulkUpdateOperatories',
  'CreateBookableAppointmentType',
  'UpdateBookableAppointmentType',
  'DeleteBookableAppointmentTypes',
  'BulkUpdateBookableAppointmentTypes',
  'ValidateBookableAppointmentTypesDeletion',
] as const satisfies (keyof Omit<typeof SchemaSchedulerV3Service, QueryEndpointName>)[];
